export type UpgradeId =
  | 'radioactive-recycler'
  | 'ship-mining-beam'
  | 'fps-mining-tool';

export interface UpgradeDefinition {
  readonly id: UpgradeId;
  readonly name: string;
  readonly description: string;
  readonly price: number;
  readonly accent: string;
  readonly accentGlow: string;
  readonly icon: string;
}

export const RADIOACTIVE_RECYCLER_FUEL_PER_ORE = 10;

export const SHIP_MINING_BEAM_PRICE = 1200;
export const FPS_MINING_TOOL_PRICE = 800;

export const UPGRADES: Record<UpgradeId, UpgradeDefinition> = {
  'ship-mining-beam': {
    id: 'ship-mining-beam',
    name: 'Industrial Mining Beam',
    description:
      'Hull-mounted mining laser. Cracks asteroids fast — kinetic guns can\'t compete.',
    price: SHIP_MINING_BEAM_PRICE,
    accent: '#9aff3c',
    accentGlow: 'rgba(154, 255, 60, 0.55)',
    icon: `
<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <linearGradient id="beam-g" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#dcff9a"/>
      <stop offset="1" stop-color="#3f8a14"/>
    </linearGradient>
  </defs>
  <rect x="6" y="22" width="32" height="4" rx="1.5" fill="#3a4a55" stroke="#1a2530" stroke-width="1"/>
  <circle cx="38" cy="24" r="4" fill="#9aff3c" stroke="#1a2530" stroke-width="1"/>
  <rect x="38" y="22" width="6" height="4" fill="url(#beam-g)" opacity="0.95"/>
  <line x1="44" y1="24" x2="32" y2="6" stroke="#9aff3c" stroke-width="1.4" opacity="0.6"/>
  <line x1="44" y1="24" x2="32" y2="42" stroke="#9aff3c" stroke-width="1.4" opacity="0.6"/>
</svg>`
  },
  'fps-mining-tool': {
    id: 'fps-mining-tool',
    name: 'Hand Mining Cutter',
    description:
      'Portable mining laser. Press 2 on a planet to equip and break ore deposits.',
    price: FPS_MINING_TOOL_PRICE,
    accent: '#9aff3c',
    accentGlow: 'rgba(154, 255, 60, 0.55)',
    icon: `
<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <rect x="10" y="20" width="20" height="8" rx="2" fill="#5a6470" stroke="#1a2530" stroke-width="1"/>
  <rect x="14" y="18" width="6" height="2" fill="#1a2530"/>
  <rect x="22" y="28" width="4" height="6" fill="#3a4a55" stroke="#1a2530" stroke-width="0.8"/>
  <circle cx="34" cy="24" r="3" fill="#9aff3c" stroke="#1a2530" stroke-width="0.8"/>
  <line x1="36" y1="24" x2="44" y2="24" stroke="#9aff3c" stroke-width="2" opacity="0.85"/>
</svg>`
  },
  'radioactive-recycler': {
    id: 'radioactive-recycler',
    name: 'Radioactive Recycler',
    description:
      'Onboard reactor module. Converts uranium ore into ship fuel through controlled fission.',
    price: 1000,
    accent: '#9aff3c',
    accentGlow: 'rgba(154, 255, 60, 0.5)',
    icon: `
<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <radialGradient id="recycler-core" cx="0.5" cy="0.5" r="0.55">
      <stop offset="0" stop-color="#dcff9a"/>
      <stop offset="0.6" stop-color="#9aff3c"/>
      <stop offset="1" stop-color="#1a3a05"/>
    </radialGradient>
  </defs>
  <circle cx="24" cy="24" r="20" fill="#0d1a05" stroke="#1a3a05" stroke-width="1.4"/>
  <circle cx="24" cy="24" r="6" fill="url(#recycler-core)"/>
  <path d="M24 8 a16 16 0 0 1 13.86 8 L24 24 Z" fill="#9aff3c" opacity="0.85"/>
  <path d="M37.86 32 a16 16 0 0 1 -27.72 0 L24 24 Z" fill="#9aff3c" opacity="0.55"/>
  <path d="M10.14 16 a16 16 0 0 1 13.86 -8 L24 24 Z" fill="#9aff3c" opacity="0.7"/>
  <circle cx="24" cy="24" r="2.4" fill="#fff"/>
</svg>`
  }
};

export function getUpgrade(id: UpgradeId): UpgradeDefinition {
  return UPGRADES[id];
}
